import React, { Component } from 'react';

const defaultState = {
    name: '',
    email: '',
    subject: '',
    text: ''
}

class Contact extends Component {

    constructor(props) {
        super(props);

        this.state = defaultState
    }

    resetForm() {
        this.setState(defaultState)
    }


    handleSubmit(event) {
        event.preventDefault()
        // Don't worry, I wrote the web server for this site and got permission to use it's email server
        // for this purpose!
        fetch('https://www.campanileproject.org/email/send',{
            method: "POST",
            body: JSON.stringify({
                name: this.state.name,
                email: "shaylandias@berkeley.edu",
                subject: `${this.state.email} - ${this.state.subject}`,
                text: this.state.text,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then((response)=>{
            console.log(response)
            if (response.status === 200){
                alert("Message Sent.");
                this.resetForm()
            } else if (response.status === 400) {
                alert("Invalid information entered in form.")
            }
            else {
                alert("Message failed to send.")
            }
        }).catch(err => {
            alert("Message failed to send.")
        })
        this.setState(defaultState)
   }

    onNameChange(event) {
        this.setState({name: event.target.value})
    }

    onEmailChange(event) {
        this.setState({email: event.target.value})
    }

    onSubjectChange(event) {
        this.setState({subject: event.target.value})
    }

    onMessageChange(event) {
        this.setState({text: event.target.value})
    }

  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var message = this.props.data.contactmessage;
    }

    return (
      <section id="contact">

         <div className="row section-head">

            <div className="two columns header-col">

               <h1><span>Get In Touch.</span></h1>

            </div>

            <div className="ten columns">

                  <p className="lead">{message}</p>

            </div>

         </div>

         <div className="row">
            <div className="eight columns">

               <form id="contactForm" onSubmit={this.handleSubmit.bind(this)} name="contactForm">
					<fieldset>

                  <div>
						   <label htmlFor="contactName">Name <span className="required">*</span></label>
						   <input type="text" size="35" id="contactName" value={this.state.name} name="contactName" onChange={this.onNameChange.bind(this)}/>
                  </div>

                  <div>
						   <label htmlFor="contactEmail">Email <span className="required">*</span></label>
						   <input type="text" size="35" id="contactEmail" name="contactEmail" value={this.state.email} onChange={this.onEmailChange.bind(this)}/>
                  </div>

                  <div>
						   <label htmlFor="contactSubject">Subject</label>
						   <input type="text" size="35" id="contactSubject" name="contactSubject" value={this.state.subject} onChange={this.onSubjectChange.bind(this)}/>
                  </div>

                  <div>
                     <label htmlFor="contactMessage">Message <span className="required">*</span></label>
                     <textarea cols="50" rows="15" id="contactMessage" name="contactMessage" value={this.state.text} onChange={this.onMessageChange.bind(this)}></textarea>
                  </div>

                  <div>
                     <button className="submit">Submit</button>
                     <span id="image-loader">
                        <img alt="" src="images/loader.gif" />
                     </span>
                  </div>
					</fieldset>
				   </form>

           <div id="message-warning"> Error boy</div>
				   <div id="message-success">
                  <i className="fa fa-check"></i>Your message was sent, thank you!<br />
				   </div>
           </div>


            <aside className="four columns footer-widgets">
               <div className="widget widget_contact">

					   <h4>Location and Contact Info</h4>
					   <p className="address" style={{color: "#bcc5d1"}}>
						   {city}, {state}<br />
						   <span><a href={"tel:" + phone} target="_blank">{phone}</a><br /></span>
                           <span><a href = {"mailto: " + email} target="_blank">{email}</a></span>
					   </p>
				   </div>
            </aside>
      </div>
   </section>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js